import * as actionTypes from "./actionTypes";

export const getCRMLevelInfo = () => ({
	type: actionTypes.GET_CRM_LEVEL_INFO_ACTION
});

export const setCRMLevelInfo = params => ({
	type: actionTypes.SET_CRM_LEVEL_INFO_ACTION,
	params
});
